module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  1")]), _vm._v(" The Starting Line: The Journey Begins")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  2")]), _vm._v(" The Color Line: Healing Racial Trauma")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  3")]), _vm._v(" The Family Line: Wounds and Wonder")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  4")]), _vm._v(" Fall in Line: The Mask")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  5")]), _vm._v(" Between the Lines: Things Lost and Found")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  6")]), _vm._v(" Out of Line: A Moral Injury")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  7")]), _vm._v(" A Fault Line: All In or Out")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  8")]), _vm._v(" The Frontline: Activism and Discipleship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("  9")]), _vm._v(" Hold the Line: The Long Wait")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("10")]), _vm._v(" The Boundary Line: Where I End and You Begin")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("11")]), _vm._v(" Walk the Line: What Matters Most")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev9"
  }, [_vm._v("12")]), _vm._v(" Finish Lines: Surrender and Acceptance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: The Genogram")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: A Forgiveness Prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Young, Gifted, and Black")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0